import {EventReducer, ReducerFromState} from "../../../@types/reducers";
import {EventSettingsObject} from "../../../@types/response";

export const getSettings = (state: ReducerFromState<EventReducer>): EventSettingsObject => state.event.settings;